import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { OnChange } from '../../../../../shared/utils/on-change-decorator.util';
import { delay, of } from 'rxjs';

@Component({
  selector: 'now-wbsuche-lib-verdienst',
  templateUrl: './verdienst.component.html',
  styleUrls: ['./verdienst.component.scss'],
  imports: [NgOptimizedImage, NgTemplateOutlet]
})
export class VerdienstComponent implements OnChanges {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @OnChange('getSafeHtml')
  @Input()
  public medianBausteine: string[] = [];

  @Input()
  public collapsed?: boolean;

  bausteine: SafeHtml[] = [];

  public async ngOnChanges(changes: SimpleChanges) {
    if (
      changes.collapsed.currentValue != changes.collapsed.previousValue ||
      changes.medianBausteine
    ) {
      let runAsync = of(null);
      if (changes.medianBausteine) {
        // add a delay to guarantee that the medianbaustein is rendered
        runAsync = runAsync.pipe(delay(20));
      }
      runAsync.subscribe(() => {
        if (changes.collapsed.currentValue === false) {
          this.enableControls();
        } else {
          this.disableControls();
        }
      });
    }
  }

  getSafeHtml(bausteine: string[]): void {
    this.bausteine = bausteine.map(this.sanitizer.bypassSecurityTrustHtml);
  }

  private enableControls() {
    const anchors = this.getAnchors();
    anchors.forEach((anchor) => {
      anchor.removeAttribute('tabindex');
    });
  }

  private disableControls() {
    const anchors = this.getAnchors();
    anchors.forEach((anchor) => {
      anchor.setAttribute('tabindex', '-1');
    });
  }

  private getAnchors() {
    return this.elementRef.nativeElement.querySelectorAll('a');
  }
}
